'use client';

//base
import React, { useState } from 'react';

import { IconButton, InputAdornment, TextField, type TextFieldProps } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const BasicPassword: React.FC<TextFieldProps> = ({ ...props }) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '6px',
          backgroundColor: '#fff'
        },

        '& .MuiInputBase-input.Mui-disabled': {
          backgroundColor: '#f0f0f0',
          borderRadius: '6px'
        }
      }}
      inputProps={{
        style: {
          padding: '8px 12px'
        }
      }}
      InputProps={{
        startAdornment: null,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleClickShowPassword} edge="end" size="small">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
      {...props}
    />
  );
};
